import { render, staticRenderFns } from "./PanelSlot.vue?vue&type=template&id=3def07a9&"
import script from "./PanelSlot.vue?vue&type=script&lang=js&"
export * from "./PanelSlot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports